import Poi from '@/components/sl-amap/components/amap-poi'
import { getStaticPath } from '@/util/request'
import { throttle } from '@/util'
import { wgs2gcj } from '@/util/map/proj'

class carMapPoi {
  constructor(map) {
    this.visible = true

    this.poiTpl = '<div class="sl-amap-poi" title="{companyName}"><i style="background-image:url({icon})"></i></div>'
    this.poiManager = new Poi(map, {
      poiTpl: this.poiTpl,
      size: [48, 48],
      offset: [-16, -37],
      handlers: {
        'link_to_car_map': `window['${linkToCarMap}']({id})`
      }
    })

    map.on('moveend', this.update)

    // map.on('zoomstart', this.beforeZoom)
    map.on('zoomend', this.update)
    map.on('resize', this.update)
  }

  setData(data) {

  }

  hide() {
    this.visible = false
  }

  show() {
    this.visible = true
  }

  update(){
    //this.fetchCompany(this.poiManager.getBounds(true))
  }
}


export default carMapPoi
